/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetClusterPopupForMapModel,
  IGetClusterPopupForMapRequest,
  IMappers,
  IGetClusterPopupForMapResponse,
  IGetClusterPopupForMapResponseError,
  TGetClusterPopupForMapResponse,
} from './types';

const defaultConfig: TGetClusterPopupForMapModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'search-engine',
  pathApi: '/v1/get-cluster-popup-for-map/',
  hostType: 'api',
} as TGetClusterPopupForMapModel;

function createGetClusterPopupForMapModel(parameters: IGetClusterPopupForMapRequest): TGetClusterPopupForMapModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetClusterPopupForMapOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetClusterPopupForMapRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetClusterPopupForMap<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetClusterPopupForMapOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetClusterPopupForMapResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetClusterPopupForMapModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetClusterPopupForMapResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetClusterPopupForMapResponseError);
    }
  }

  return { response, statusCode } as TGetClusterPopupForMapResponse;
}

export { defaultConfig, createGetClusterPopupForMapModel, fetchGetClusterPopupForMap };
